import * as angular from 'angular';
import { Units } from '../constants/units';

let conversions: object = {};

function addConversion(fromUnit: Units, toUnit: Units, ratio: number) {
  conversions[fromUnit] = conversions[fromUnit] || {};
  conversions[fromUnit][toUnit] = ratio;
}

addConversion(Units.gallons, Units.ounces, 128.0);
addConversion(Units.gallons, Units.liters, 3.785);
addConversion(Units.ounces, Units.gallons, 0.0078125);
addConversion(Units.ounces, Units.liters, 0.0296);
addConversion(Units.liters, Units.gallons, 0.26420079);
addConversion(Units.liters, Units.ounces, 33.8177011);
addConversion(Units.feet, Units.meters, 0.305);
addConversion(Units.meters, Units.feet, 3.27868852);

class FromConversion {
  value: number;
  fromUnit: Units;

  constructor(value: number, unit: Units) {
    this.value = value;
    this.fromUnit = unit;
  }

  private wrapResult(value: number, unit: Units): object {
    let result = {};
    result[unit] = value;
    return result;
  }

  to(toUnit: Units): object {
    try {
      if (this.fromUnit === toUnit) return this.wrapResult(this.value, toUnit);

      const ratio: number = conversions[this.fromUnit][toUnit];

      if (ratio === undefined) throw 'Bad';

      return this.wrapResult(ratio * this.value, toUnit);
    } catch (e) {
      throw `Invalid conversion: ${this.fromUnit} to ${toUnit}`;
    }
  }
}

const Convert = Units =>
  function(value: number, fromUnit: Units): FromConversion {
    return new FromConversion(value, fromUnit);
  };

export default Convert;

angular.module('ciApp').factory('Convert', ['Units', Convert]);



// WEBPACK FOOTER //
// ./common/services/convert.service.ts